import { State } from "@store/types";

export function getEmployeeVoiceReportsState(state: State) {
  return state.get("insights_voice_reports");
}
